import { cx } from '@twind/core';

export default function ExternalLinkIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={cx('ostro-external-link-icon', '~(text-[#1F1748])', className)}
      data-testid="external-link-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.1 4.49961C2.91435 4.49961 2.7363 4.57336 2.60503 4.70463C2.47375 4.83591 2.4 5.01396 2.4 5.19961V12.8996C2.4 13.0853 2.47375 13.2633 2.60503 13.3946C2.7363 13.5259 2.91435 13.5996 3.1 13.5996H10.8C10.9857 13.5996 11.1637 13.5259 11.295 13.3946C11.4262 13.2633 11.5 13.0853 11.5 12.8996V8.69961C11.5 8.31301 11.8134 7.99961 12.2 7.99961C12.5866 7.99961 12.9 8.31301 12.9 8.69961V12.8996C12.9 13.4566 12.6787 13.9907 12.2849 14.3845C11.8911 14.7784 11.357 14.9996 10.8 14.9996H3.1C2.54305 14.9996 2.0089 14.7784 1.61508 14.3845C1.22125 13.9907 1 13.4566 1 12.8996V5.19961C1 4.64265 1.22125 4.10851 1.61508 3.71469C2.0089 3.32086 2.54305 3.09961 3.1 3.09961H7.3C7.6866 3.09961 8 3.41301 8 3.79961C8 4.18621 7.6866 4.49961 7.3 4.49961H3.1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40039 1.7C9.40039 1.3134 9.71379 1 10.1004 1H14.3004C14.687 1 15.0004 1.3134 15.0004 1.7V5.9C15.0004 6.2866 14.687 6.6 14.3004 6.6C13.9138 6.6 13.6004 6.2866 13.6004 5.9V2.4H10.1004C9.71379 2.4 9.40039 2.0866 9.40039 1.7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7954 1.20503C15.0687 1.47839 15.0687 1.92161 14.7954 2.19497L7.09537 9.89498C6.822 10.1683 6.37878 10.1683 6.10542 9.89498C5.83205 9.62161 5.83205 9.17839 6.10542 8.90503L13.8054 1.20503C14.0788 0.931658 14.522 0.931658 14.7954 1.20503Z"
        fill="currentColor"
      />
    </svg>
  );
}
